import { render, staticRenderFns } from "./AddProjectAlert.vue?vue&type=template&id=f1120b10&scoped=true&"
import script from "./AddProjectAlert.vue?vue&type=script&lang=js&"
export * from "./AddProjectAlert.vue?vue&type=script&lang=js&"
import style0 from "./AddProjectAlert.vue?vue&type=style&index=0&id=f1120b10&prod&scoped=true&lang=css&"
import style1 from "./AddProjectAlert.vue?vue&type=style&index=1&id=f1120b10&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1120b10",
  null
  
)

export default component.exports